import { Select } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Flex, Icon } from 'ui';

const { Option } = Select;

const StyledSelect = styled(Select)`
  font-size: 16px;
  font-weight: 400;
  width: 100%;
`;

const StyledIcon = styled(Icon)`
    margin-right: 5px;

    ${p => p.severity === 'informational' && `
        color: ${p.theme.colors.alerts[3]} !important;
    `}

    ${p => p.severity === 'moderate' && `
        color: ${p.theme.colors.alerts[2]} !important;
    `}

    ${p => p.severity === 'high' && `
        color: ${p.theme.colors.alerts[1]} !important;
    `}
`;

const SeveritySelector = ({
  options,
  value = '',
  onChange,
  disabled,
}) => {
  const triggerChange = (changedValue) => {
    if (onChange) {
      onChange(changedValue);
    }
  };

  return (
    <StyledSelect
      onSelect={triggerChange}
      value={value}
      disabled={disabled}
      data-test-id='dropdown-announcement-severity'
    >
      {options?.map(s => <Option key={s.id} >
        <Flex aic>
          {s?.icon && <StyledIcon type={s.icon} severity={s.id} />}{s.description}
        </Flex>
      </Option>)}
    </StyledSelect>
  );
};

SeveritySelector.propTypes = {
  options: PropTypes.array,
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default SeveritySelector;
